/** The public bot documentation lives here (docs/BOTS.md, rendered by DocsPage). */
export const DOCS_PATH = '/developers';

export function isDocsPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, '') === DOCS_PATH;
}
